import { render } from "./DetailColumnToolPanel.vue?vue&type=template&id=0fdede9b"
import script from "./DetailColumnToolPanel.vue?vue&type=script&lang=js"
export * from "./DetailColumnToolPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__